var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDocument = function SvgDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 46 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.723 13.166v-11.9l12.167 11.9H23.723Z",
    stroke: "#231F20",
    strokeWidth: 1.378,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.89 18.332v-5.166l-12.168-11.9H2.792c-.612 0-1.147.498-1.147 1.11v43.429c0 .612.497 1.11 1.147 1.11h31.95c.612 0 1.148-.498 1.148-1.11v-5.089M24.105 39.225H6.504M20.01 34.174H6.505M19.246 29.123H6.504M20.547 24.11H6.504M25.291 19.06H6.504M20.853 14.009H6.503M20.279 8.958H6.504",
    stroke: "#231F20",
    strokeWidth: 1.378,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.246 31.436c1.07-6.592-3.407-12.803-9.998-13.872-6.592-1.07-12.803 3.406-13.872 9.998-1.07 6.591 3.406 12.802 9.998 13.872 6.591 1.07 12.802-3.406 13.872-9.998Z",
    stroke: "#231F20",
    strokeWidth: 1.378,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m40.137 26.062-2.832-3.214-7.155 8.189-4.056-4.63-2.831 3.214 6.887 7.844 2.793-3.214 7.194-8.189Z",
    stroke: "#231F20",
    strokeWidth: 1.378,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgDocument;